import { relations, sql } from 'drizzle-orm'
import { AnyPgColumn, index, pgEnum, pgTable, text } from 'drizzle-orm/pg-core'
import {
  getBaseFields,
  getBaseIndexes,
  getIdReference,
  getMonetaryField,
  getNullableIdReference,
  getTimestampWithTimezone,
} from '../common/utils'
import { invoicePayments } from './invoicePayment'
import { visits, visitTasks } from './visit'
import { visitLineItems } from './visitLineItem'

export const invoiceStatusEnum = pgEnum('invoice_status', [
  'finalized',
  'sent',
  'paid',
  'void',
])

export const invoices = pgTable(
  'invoices',
  {
    ...getBaseFields(),
    visitId: getIdReference(() => visits.id),
    stripeInvoiceId: text().notNull().unique(),
    invoiceNumber: text().notNull(),
    referenceNumber: text().notNull().unique(),
    totalAmount: getMonetaryField().notNull(),
    taxableTotal: getMonetaryField(),
    taxAmount: getMonetaryField(),
    status: invoiceStatusEnum().notNull().default('finalized'),
    sentAt: getTimestampWithTimezone(),
    paidAt: getTimestampWithTimezone(),
    voidedAt: getTimestampWithTimezone(),
    voidReason: text(),
    voidsInvoiceId: getNullableIdReference((): AnyPgColumn => invoices.id),
    dueDate: getTimestampWithTimezone()
      .notNull()
      .default(sql`now() + interval '14 days'`),
  },
  (table) => [
    ...getBaseIndexes('invoices', table),
    index('invoices_visit_id_idx').on(table.visitId),
  ],
)

export const invoicesRelations = relations(invoices, ({ one, many }) => ({
  visit: one(visits, {
    fields: [invoices.visitId],
    references: [visits.id],
  }),
  voidedInvoice: one(invoices, {
    fields: [invoices.voidsInvoiceId],
    references: [invoices.id],
    relationName: 'invoiceRevision',
  }),
  invoicePayments: many(invoicePayments),
  invoiceLines: many(visitTasks),
  invoiceMaterialLines: many(visitLineItems),
}))
